const info = {
    $schema: '../assetlist.schema.json',
    chain_name: 'avalanche',
    assets: [
        {
            description: 'AVAX is the native token of Avalanche. It is a hard-capped, scarce asset that is used to pay for fees, secure the platform through staking, and provide a basic unit of account between the multiple subnets created on Avalanche.',
            denom_units: [{
                    denom: 'wei',
                    exponent: 0
                }, {
                    denom: 'avax',
                    exponent: 18
                }],
            type_asset: 'evm-base',
            base: 'wei',
            name: 'Avalanche',
            display: 'avax',
            symbol: 'AVAX',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/avax.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/avax.svg'
            },
            coingecko_id: 'avalanche-2',
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/avax.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/avax.svg'
                }]
        },
        {
            description: 'The wrapped ERC-20 representation of AVAX, the native token of Avalanche.',
            type_asset: 'erc20',
            address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
            denom_units: [{
                    denom: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
                    exponent: 0,
                    aliases: ['wavax-wei']
                }, {
                    denom: 'wavax',
                    exponent: 18
                }],
            base: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
            name: 'Wrapped AVAX',
            display: 'wavax',
            symbol: 'WAVAX',
            traces: [{
                    type: 'wrapped',
                    counterparty: {
                        chain_name: 'avalanche',
                        base_denom: 'wei'
                    },
                    provider: 'Avalanche'
                }],
            logo_URIs: {
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/wavax.svg'
            },
            coingecko_id: 'wrapped-avax',
            images: [{
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/wavax.svg'
                }]
        },
        {
            description: 'USDC is a fully collateralized US Dollar stablecoin developed by CENTRE, the open source project with Circle being the first of several forthcoming issuers.',
            type_asset: 'erc20',
            address: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
            denom_units: [{
                    denom: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
                    exponent: 0,
                    aliases: ['uusdc']
                }, {
                    denom: 'usdc',
                    exponent: 6
                }],
            base: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
            name: 'USD Coin',
            display: 'usdc',
            symbol: 'USDC',
            traces: [{
                    type: 'additional-mintage',
                    counterparty: {
                        chain_name: 'ethereum',
                        base_denom: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48'
                    },
                    provider: 'Circle'
                }],
            logo_URIs: {
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg'
            },
            coingecko_id: 'usd-coin',
            images: [{
                    image_sync: {
                        chain_name: 'ethereum',
                        base_denom: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48'
                    },
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg'
                }]
        },
        {
            description: 'Multi-Collateral Dai, brings a lot of new and exciting features, such as support for new CDP collateral types and Dai Savings Rate.',
            type_asset: 'erc20',
            address: '0xc5fa5669e326da8b2c35540257cd48811f40a36b',
            denom_units: [{
                    denom: '0xc5fa5669e326da8b2c35540257cd48811f40a36b',
                    exponent: 0,
                    aliases: ['dai-wei']
                }, {
                    denom: 'axldai',
                    exponent: 18
                }],
            base: '0xc5fa5669e326da8b2c35540257cd48811f40a36b',
            name: 'Axelar Wrapped DAI',
            display: 'axldai',
            symbol: 'axlDAI',
            traces: [{
                    type: 'bridge',
                    counterparty: {
                        chain_name: 'axelar',
                        base_denom: 'dai-wei'
                    },
                    provider: 'Axelar'
                }],
            logo_URIs: {
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg'
            },
            images: [{
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg'
                }]
        },
        {
            description: 'Frax is a fractional-algorithmic stablecoin protocol. It aims to provide a highly scalable, decentralized, algorithmic money in place of fixed-supply assets like BTC. Additionally, FXS is the value accrual and governance token of the entire Frax ecosystem.',
            type_asset: 'erc20',
            address: '0x4914886dbb8aad7a7456d471eaab10b06d42348d',
            denom_units: [{
                    denom: '0x4914886dbb8aad7a7456d471eaab10b06d42348d',
                    exponent: 0,
                    aliases: ['frax-wei']
                }, {
                    denom: 'axlfrax',
                    exponent: 18
                }],
            base: '0x4914886dbb8aad7a7456d471eaab10b06d42348d',
            name: 'Axelar Wrapped Frax',
            display: 'axlfrax',
            symbol: 'axlFRAX',
            traces: [{
                    type: 'bridge',
                    counterparty: {
                        chain_name: 'axelar',
                        base_denom: 'frax-wei'
                    },
                    provider: 'Axelar'
                }],
            logo_URIs: {
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frax.svg'
            },
            images: [{
                    image_sync: {
                        chain_name: 'axelar',
                        base_denom: 'frax-wei'
                    },
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frax.svg'
                }]
        },
        {
            description: 'USDC is a fully collateralized US Dollar stablecoin developed by CENTRE, the open source project with Circle being the first of several forthcoming issuers.',
            type_asset: 'erc20',
            address: '0xfab550568C688d5d8a52c7d794cb93edc26ec0ec',
            denom_units: [{
                    denom: '0xfab550568C688d5d8a52c7d794cb93edc26ec0ec',
                    exponent: 0,
                    aliases: ['uusdc']
                }, {
                    denom: 'axlusdc',
                    exponent: 6
                }],
            base: '0xfab550568C688d5d8a52c7d794cb93edc26ec0ec',
            name: 'Axelar Wrapped USDC',
            display: 'axlusdc',
            symbol: 'axlUSDC',
            traces: [{
                    type: 'bridge',
                    counterparty: {
                        chain_name: 'axelar',
                        base_denom: 'uusdc'
                    },
                    provider: 'Axelar'
                }],
            logo_URIs: {
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg'
            },
            images: [{
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg'
                }]
        },
        {
            description: 'Tether gives you the joint benefits of open blockchain technology and traditional currency by converting your cash into a stable digital currency equivalent.',
            type_asset: 'erc20',
            address: '0xf976ba91b6bb3468c91e4f02e68b37bc64a57e66',
            denom_units: [{
                    denom: '0xf976ba91b6bb3468c91e4f02e68b37bc64a57e66',
                    exponent: 0,
                    aliases: ['uusdt']
                }, {
                    denom: 'axlusdt',
                    exponent: 6
                }],
            base: '0xf976ba91b6bb3468c91e4f02e68b37bc64a57e66',
            name: 'Axelar Wrapped USDT',
            display: 'axlusdt',
            symbol: 'axlUSDT',
            traces: [{
                    type: 'bridge',
                    counterparty: {
                        chain_name: 'axelar',
                        base_denom: 'uusdt'
                    },
                    provider: 'Axelar'
                }],
            logo_URIs: {
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg'
            },
            images: [{
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg'
                }]
        }
    ]
};
export default info;
